import { render } from "./UGCPanelDungeonForm.vue?vue&type=template&id=7c403efc&scoped=true"
import script from "./UGCPanelDungeonForm.vue?vue&type=script&lang=js"
export * from "./UGCPanelDungeonForm.vue?vue&type=script&lang=js"

import "./UGCPanelDungeonForm.vue?vue&type=style&index=0&id=7c403efc&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c403efc"]])

export default __exports__